module.exports = __webpack_public_path__ + "PERUVIANserve-6.524930cf.png";